var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpertItemBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 654,
    height: 157,
    viewBox: "0 0 654 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 124C95.2269 124 125 94.2269 125 57.5C125 48.9548 123.388 40.786 120.452 33.2811C117.365 25.3893 122.5 15 130.975 15H624C640.569 15 654 28.4315 654 45V127C654 143.569 640.569 157 624 157H30C13.4315 157 0 143.569 0 127V112.805C0 106.581 10.0112 103.431 14.6924 107.533C26.3927 117.786 41.7206 124 58.5 124Z",
    fill: "#F6F6F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertItemBg);
export default __webpack_public_path__ + "static/media/expert_item_bg.396d699aac6e1d7b89d195d7bd41174a.svg";
export { ForwardRef as ReactComponent };